import { ArrowIcon } from "assets/icons";
import cn from "classnames";

import { CounterInputControlsProps } from "./CounterInputControls.types";

import styles from "./CounterInputControls.module.scss";

const CounterInputControls = ({
  value,
  max,
  min,
  onChange,
  disabled
}: CounterInputControlsProps) => {
  return (
    <div className={styles.controls}>
      <button
        type="button"
        className={cn(styles.controls_btn, styles.controls_btn__up)}
        disabled={disabled ?? (max ? value >= max : undefined)}
        onClick={() => onChange(+value + 1)}
      >
        <ArrowIcon />
      </button>

      <button
        type="button"
        className={styles.controls_btn}
        onClick={() => onChange(+value - 1)}
        disabled={disabled ?? (min ? value <= min : undefined)}
      >
        <ArrowIcon />
      </button>
    </div>
  );
};

export default CounterInputControls;
